export class PlanAttachment {
    public id: string;
    public idHeader: string;
    public fileName: string;
    public fileBlob: [];
    public notes: string;
    public sessionId: string;
    public userUpload: string;
    public dataUpload: Date;
    public toDelete: boolean;
    
    constructor(
        id?: string,
        idHeader?: string,
        fileName?: string,
        fileBlob?: [],
        notes?: string,
        sessionId?: string,
        userUpload?: string,
        dataUpload?: Date,
        toDelete?: boolean,
      ) {
        this.id = id;
        this.idHeader = idHeader;
        this.fileName = fileName;
        this.fileBlob = fileBlob;
        this.notes = notes;
        this.sessionId = sessionId;
        this.userUpload = userUpload;
        this.dataUpload = dataUpload;
        this.toDelete = toDelete;
      }
}